module["exports"] = [
  "кат #",
  "стан ##"
];
